import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionReveal } from './SectionReveal';
const testimonials = [{
  initials: 'MR',
  quote: 'Tenía 34 sujetos obligados para encuadrar. Entre los que claramente no aplica, los que claramente sí y los casos que no eran tan obvios, iba a ser una tarde entera. Con el checklist lo resolví en menos de una hora. Los casos borde están contemplados, que era justo lo que me frenaba.',
  name: 'Marcelo R.',
  role: 'Contador Público · Estudio propio · Palermo, CABA'
}, {
  initials: 'VT',
  quote: 'Lo que más me sirvió fueron los modelos de Notificación diferenciados por tipo de sujeto obligado. El mensaje para un director de SA no es el mismo que para un abogado que cobra honorarios judiciales. Eso me hubiera llevado horas armarlo bien. Ya estaba hecho.',
  name: 'Valeria T.',
  role: 'Contadora Pública · Socia de estudio · Córdoba Capital'
}, {
  initials: 'JP',
  quote: 'El cronograma visual lo imprimí y lo pegué al lado del monitor. Cada vez que un sujeto obligado consulta desde cuándo le aplica, lo miro y respondo en diez segundos con la referencia normativa incluida. Eso solo ya justificó lo que pagué.',
  name: 'Jorge P.',
  role: 'Contador Público · Independiente · Rosario, Santa Fe'
}, {
  initials: 'LB',
  quote: 'Trabajo con tres colegios privados y dos prepagas. Sabía que me iba a llover consultas en cuanto se corriera la voz. Mandé las Notificaciones la semana que descargué el pack. Cero llamados de pánico después. Los sujetos obligados llegaron informados al vencimiento.',
  name: 'Laura B.',
  role: 'Contadora Pública · San Isidro, GBA'
}];
export function SocialProof() {
  return <section className="w-full bg-base" data-id="element-237" data-mp="skheby1a3wmo">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-20" data-id="element-238" data-mp="slaf8idk3rww">
        <SectionReveal data-id="element-239" data-mp="nlo3kdddmjq7">
          <h2 className="text-center text-2xl font-black leading-tight text-ink sm:text-3xl md:text-4xl" data-id="element-240" data-mp="nmg0bripmni2">
            Contadores que ya tienen su cartera encuadrada
          </h2>
        </SectionReveal>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-241" data-mp="1hc6m3rivnjx2">
          {testimonials.map((t, i) => <motion.div key={t.initials} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} className="flex flex-col rounded-2xl border border-alt bg-alt/50 p-6 shadow-sm" data-id="element-242" data-mp="1m96x8gul3cv1" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-243" data-mp="2ez5o8hsc9k2c">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-dark text-sm font-bold text-white" data-id="element-244" data-mp="2f0qgu1v3esxk">
                  {t.initials}
                </span>
                <span className="flex" data-id="element-245" data-mp="8by9744nwepk">
                  {[...Array(5)].map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-accent text-accent" data-id="element-246" data-mp="39z6zxknrnu7" data-mpi={s} />)}
                </span>
              </div>
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-ink" data-id="element-247" data-mp="3pkl6xly02zn4">
                "{t.quote}"
              </blockquote>
              <p className="mt-4 text-sm font-semibold text-ink" data-id="element-248" data-mp="m2be0xm9bdao">
                — {t.name}
                <span className="block font-normal text-ink-soft" data-id="element-249" data-mp="hb1vegz4la8a">
                  {t.role.replace(t.name + ', ', '')}
                </span>
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}